
























import Vue from "vue";
import { Info } from "@/models/Info";

export default Vue.extend({
  data() {
    return {
      columns: [
        { field: "category", title: "Category", width: "250" },
        { field: "displayName", title: "Display Name" },
        { field: "description", title: "Description" },
        { field: "stringValue", title: "Setting Value", width: "150" },
        {
          field: "action",
          title: " ",
          width: "75"
        }
      ]
    };
  },
  props: {
    info: {
      type: Object as () => Info,
      default: null
    }
  },
  methods: {
    getNestedValue(fieldName: string, dataItem) {
      const path = fieldName.split(".");
      let data = dataItem;
      path.forEach(p => {
        data = data ? data[p] : undefined;
      });
      return data;
    },
    onEditBtnClick(dataItem): any {
      this.$emit("editAction", { ...dataItem });
    }
  }
});
